module.exports = __webpack_public_path__ + "static/chromatic-site-a68cb7971d029a613e0c2c172eee7855.png";